import React, { CSSProperties, useEffect, useRef } from "react";
import {
	dateFormat,
	east8ToEast9,
	formatVolume,
	getColorByNumber,
	partiallyHideHash,
	pxToRem,
	setDataToClipboard,
} from "@/util/common";
import { createUseStyles } from "react-jss";
import useRouter from "@/hooks/useRouter";
import { has, isEmpty } from "lodash";
import CustomEmpty from "../Empty";
import { isDef } from "@/util/validate";
import { InfiniteScroll, PullToRefresh } from "antd-mobile";
import InfiniteScrollContent from "../InfiniteScrollContent";
import useCustomTranslation from "@/hooks/useTranslation";
interface StatusResponse {
	text: string;
	game: string;
	color: string;
	cash?: string;
}
// 再修改充值类型&记录类型
export const getStatusResponse = (
	status: number,
	t: (key: string) => string
): StatusResponse => {
	switch (status) {
		case 0:
			return {
				cash: t("ToBeReviewed"),
				text: t("NoPayment"),
				game: t("NoPayment"),
				color: "#FFD179",
			};
		case 1:
			return {
				cash: t("Success"),
				text: t("NoPayment"),
				game: t("NoPayment"),
				color: "#FFD179",
			};
		case 2:
			return {
				text: t("PaymentCompletion"),
				game: t("Unsettled"),
				color: "#FFD179",
			};
		case 3:
			return {
				text: t("Success"),
				game: t("Settled"),
				color: "#FFD179",
			};
		case 4:
			return {
				text: t("Cancel"),
				game: t("Cancel"),
				color: "#FFD179",
			};
		case -1:
			return {
				cash: t("NotPass"),
				text: t("Cancel"),
				game: t("Cancel"),
				color: "#FFD179",
			};
		default:
			return { text: "", game: "", color: "" };
	}
};

const TableTbody: React.FC<{
	ITableCols: any[];
	ITableData: any[];
	targetData?: Record<string, any> | null;
	styleRich?: Record<string, any>;
	handleRefresh: () => Promise<any>;
	handleFetchMore: (isRetry: boolean) => Promise<void>;
	hasMore: boolean;
	isPullToRefresh?: boolean;
}> = ({
	ITableCols,
	ITableData,
	targetData,
	styleRich,
	handleRefresh,
	handleFetchMore,
	hasMore,
	isPullToRefresh = true,
}) => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const { customNavigate, location } = useRouter();
	const elementParentRef = useRef<HTMLDivElement>(null);
	const elementTableRef = useRef<HTMLTableElement>(null);

	const calculateDifference = (
		expression: string,
		targetData: Record<string, any>
	) => {
		const expressionData = expression.split("=")[1].split("-"); //特定的公式必有=&-
		const coinIn = targetData[expressionData[0]] || 0;
		const coinOut = targetData[expressionData[1]] || 0;
		let difference: number;
		switch (expression) {
			case "difference=coinIn-coinOut":
				difference = accuracyCalculation(coinIn - coinOut);
				break;
			case "difference=coinOut-coinIn":
				difference = accuracyCalculation(coinOut - coinIn);
				break;
			case "difference=coinIn-settleCoinOut":
				difference = accuracyCalculation(coinIn - coinOut);
				break;
			case "difference=settleCoinOut-coinIn":
				difference = accuracyCalculation(coinIn - coinOut);
				break;
			default:
				throw new Error("Invalid expression");
		}
		return difference;
	};

	const accuracyCalculation = (value: number) => {
		return Math.round(value * 1000) / 1000;
	};

	useEffect(() => {
		if (elementParentRef.current && elementTableRef.current) {
			const pw = elementParentRef.current.offsetWidth;
			const tw = elementTableRef.current.offsetWidth;
			if (ITableData && !ITableData.length && tw > pw) {
				elementParentRef.current.scrollLeft = (tw - pw) / 2;
			}
		}
	}, [ITableData]);

	// 	游戏
	// 1: 未支付/non-payment
	// 2: 未结算/ unsettled
	// 3: 已结算 /settled
	// 4：取消/ cancel
	// 其他/success

	// 充值/提现

	// 1: 未支付/no payment
	// 2: 已支付(待结算)/ payment completion
	// 3: 已支付(完结)/ success
	// 4：取消/ cancel
	// 其他/success
	// 1/未支付 2/已支付(待结算) 3/已支付(完结)

	const tableElementHandle = () => {
		return (
			<table className={classes.customTable} ref={elementTableRef}>
				<thead>
					<tr>
						{ITableCols.map((item, index) => {
							return <th key={index}>{t(item.title)}</th>;
						})}
					</tr>
				</thead>
				<tbody>
					{isEmpty(ITableData) ? (
						<tr>
							<td colSpan={ITableCols.length}>
								<CustomEmpty />
							</td>
						</tr>
					) : (
						ITableData.map((item, index) => {
							const keyValue =
								item.uid + "_" + item.orderId + "_" + index;
							return (
								<tr key={keyValue}>
									{ITableCols.map((subItem, subIndex) => {
										const key = subItem.key;
										const subKeyValue =
											keyValue + key + "-" + subIndex;
										let colorWinLose = "";
										let itemValue = item[key] ?? "-";
										const customNavigateHandle = () => {
											const pathname = location.pathname;
											if (
												subItem.isNavigate &&
												!pathname.includes(subItem.page)
											) {
												const outerParams = {
													nickname: item["nickname"],
													walletAddress:
														item["walletAddress"],
													inviteRemake:
														item["inviteRemake"],
												};
												customNavigate(
													subItem.page +
														"/" +
														item["uid"] +
														"/" +
														JSON.stringify(
															outerParams
														)
												);
											}
										};

										let style: CSSProperties = {
											textDecoration: subItem.underline
												? "underline"
												: "none",
										};
										if (subItem.multiplyLine) {
											style = {
												...style,
												whiteSpace: "pre-wrap",
											};
										}
										if (subItem.isWinLose) {
											// 正负值
											if (subItem.type) {
												colorWinLose =
													item["type"] === 1
														? "win"
														: "lose"; //	总类型 1/入金 2/出金
												itemValue =
													item["type"] === 1
														? "+" + itemValue
														: "-" + itemValue;
											} else {
												if (
													subItem.key.includes(
														"rewardCoin"
													)
												) {
													const rewardCoin =
														item["rewardCoin"] || 0;
													const coin =
														item["coin"] || 0;
													itemValue =
														accuracyCalculation(
															rewardCoin - coin
														);
												}
												colorWinLose =
													getColorByNumber(itemValue);
											}
										}
										if (subItem.isStatus) {
											// 状态值
											const statusData: any =
												getStatusResponse(itemValue, t);
											let sVal =
												statusData[subItem.statusKey] ||
												statusData.text;

											return (
												<td
													style={{
														...style,
														color: statusData.color,
													}}
													key={subKeyValue}
												>
													{sVal}
												</td>
											);
										}
										if (
											subItem["title"].includes(
												"Address"
											) &&
											!isEmpty(itemValue)
										) {
											itemValue =
												partiallyHideHash(itemValue);
										}
										if (subItem.wlmoney) {
											const rewardCoin =
												item["rewardCoin"] || 0;
											const coin = item["coin"] || 0;
											colorWinLose = getColorByNumber(
												rewardCoin - coin
											);
											itemValue = accuracyCalculation(
												rewardCoin - coin
											);
											if (item["status"] === 2) {
												itemValue = "-";
											}
										}
										if (subItem.underline) {
											colorWinLose = "c82E8FF";
										}
										if (subItem.key === "handler") {
											const handlerNickname =
												item["handlerNickname"] || "";
											const handlerWalletAddress =
												partiallyHideHash(
													item[
														"handlerWalletAddress"
													] ?? ""
												);
											itemValue =
												handlerNickname +
												" " +
												handlerWalletAddress;
										}
										if (subItem.key === "handlerNickname") {
											itemValue =
												item["handlerNickname"] ||
												item["nickname"];
											if (item["handler"] === "-1") {
												itemValue = "CG Official";
											}
										}
										if (
											subItem.key ===
											"handlerWalletAddress"
										) {
											itemValue = partiallyHideHash(
												item["handlerWalletAddress"] ??
													item["walletAddress"]
											);
											if (item["handler"] === "-1") {
												itemValue = "-";
											}
										}
										if (subItem.key === "Paicai") {
											if (item["status"] === 2) {
												itemValue = "-";
											}
										}
										if (subItem.key === "zone") {
											itemValue = "GMT+9";
										}

										if (subItem.key === "orderId,refId") {
											itemValue = item["orderId"];
											if (item["refId"]) {
												itemValue +=
													"\n" +
													item["refId"].split(
														"##"
													)[0];
											}
										}

										if (subItem.key === "transNo,refId") {
											itemValue = item["transNo"];
											if (item["refId"]) {
												itemValue +=
													"\n" +
													item["refId"].split(
														"##"
													)[0];
											}
										}

										if (
											subItem.key === "createTime" ||
											subItem.key === "updateTime"
										) {
											const time = item[
												subItem.key
											]?.replace(/-/g, "/");
											if (time.length) {
												itemValue = dateFormat(
													east8ToEast9(
														time
													).getTime(),
													"YYYY-MM-dd hh:mm:ss"
												);
											} else {
												itemValue = "-";
											}
										}
										if (
											subItem.key === "agentPnl" &&
											isDef(itemValue)
										) {
											let commission =
												item["commission"] ?? 0;
											let returnWater =
												item["returnWater"] ?? 0;
											if (itemValue !== "-") {
												itemValue = accuracyCalculation(
													+itemValue +
														commission -
														returnWater
												);
											}
										}
										if (subItem.isCopy) {
											return (
												<td
													style={{
														...style,
														color: "#82E8FF",
													}}
													key={subKeyValue}
													onClick={() =>
														setDataToClipboard(
															itemValue,
															t("CopySuccess")
														)
													}
												>
													{isDef(itemValue)
														? subItem.multiplyLine
															? itemValue
															: partiallyHideHash(
																	itemValue ??
																		""
															  )
														: "-"}
												</td>
											);
										}
										return (
											<td
												onClick={customNavigateHandle}
												key={subKeyValue}
												className={colorWinLose}
												style={style}
											>
												{isDef(itemValue)
													? itemValue
													: "-"}
											</td>
										);
									})}
								</tr>
							);
						})
					)}
				</tbody>
				{!isEmpty(targetData) && (
					<tfoot>
						<tr>
							{ITableCols.map((item, index) => {
								if (has(item, "total")) {
									const totalValue = item["total"] ?? "-";
									if (index === 0) {
										return (
											<td key={index}>{totalValue}</td>
										);
									} else if (
										totalValue.includes("difference")
									) {
										const dissValue = calculateDifference(
											totalValue,
											targetData
										);
										let colorWinLose =
											getColorByNumber(dissValue);
										return (
											<td
												key={index}
												className={colorWinLose}
											>
												{dissValue}
											</td>
										);
									} else {
										return (
											<td key={index}>
												{targetData[totalValue]
													? formatVolume(
															targetData[
																totalValue
															]
													  )
													: "-"}
												{has(item, "settleCoinOut") && (
													<div>
														{formatVolume(
															targetData[
																"settleCoinOut"
															]
														)}
														({t("Settled")})
													</div>
												)}
											</td>
										);
									}
								} else {
									return <td key={index}></td>;
								}
							})}
						</tr>
					</tfoot>
				)}
			</table>
		);
	};

	return (
		<div
			className={classes.TableTbodyWrap}
			style={styleRich}
			ref={elementParentRef}
		>
			{isPullToRefresh ? (
				<PullToRefresh
					onRefresh={handleRefresh}
					canReleaseText={t("canReleaseText")}
					completeText={t("completeText")}
					pullingText={t("pullingText")}
					refreshingText={t("refreshingText")}
				>
					{tableElementHandle()}
					{ITableData.length > 0 && (
						<InfiniteScroll
							loadMore={handleFetchMore}
							hasMore={hasMore}
						>
							<InfiniteScrollContent hasMore={hasMore} />
						</InfiniteScroll>
					)}
				</PullToRefresh>
			) : (
				tableElementHandle()
			)}
		</div>
	);
};

export default TableTbody;

const useStyles = createUseStyles({
	TableTbodyWrap: {
		position: "relative",
		height: "100%",
		overflowX: "auto",
		whiteSpace: "nowrap",
		borderRadius: pxToRem(8),
		background: "#1E212A",
		// borderImageSource: "linear-gradient(180deg, #2E3A61 0%, #353F63 100%)",
	},
	customTable: {
		borderCollapse: "collapse",
		width: "100%",
		fontSize: pxToRem(11),
		fontWeight: "400",
		"& thead": {
			position: "sticky",
			top: 0,
			zIndex: 3,
			borderTopLeftRadius: pxToRem(8),
			borderTopRightRadius: pxToRem(8),
		},
		"& th": {
			color: "#868FA8",
			backgroundColor: "#181A22",
			"&:nth-child(1)": {
				position: "sticky",
				left: 0,
				zIndex: 2,
				backgroundColor: "#181A22",
			},
		},
		"& tfoot": {
			position: "sticky",
			zIndex: 10,
			bottom: 0,
			color: "#FFFFFF",
			backgroundColor: "#181A22",
		},
		"& th, & td": {
			border: "none",
			minWidth: pxToRem(72),
			height: pxToRem(40),
			// lineHeight: pxToRem(40),
			textAlign: "center",
			padding: {
				left: pxToRem(5),
				right: pxToRem(5),
			},
			"&.c82E8FF": {
				color: "#82E8FF",
			},
		},
		"& td": {
			height: pxToRem(40),
			"&:nth-child(1)": {
				position: "sticky",
				left: 0,
				zIndex: 1,
				maxWidth: pxToRem(100),
				overflow: "hidden",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap",
				backgroundColor: "#181A22",
			},
			"&:first-child:only-child": {
				backgroundColor: "#0000",
			},
		},
		"& tbody": {
			"& tr": {
				color: "#FFFFFF",
				"&:nth-child(even)": {
					backgroundColor: "#181A22",
				},
			},
		},
	},
});
